<template>
  <div class="btn__wrapper">
    <btn-select
      v-for="answer in answers"
      @click.native.once="handleClick(answer.text)"
    ><img :src="answer.image"><span>{{ answer.text }}</span>
    </btn-select>
  </div>
</template>

<script>
import BtnSelect from '../common/BtnSelect'

export default {
  components: {
    'btn-select': BtnSelect
  },
  data () {
    return {
      answers: [
        {
          text: 'Single Family',
          image: require('../../assets/img/home_1.svg')
        },
        {
          text: 'Multi Family',
          image: require('../../assets/img/home_3.svg')
        },
        {
          text: 'Town Home/Condo',
          image: require('../../assets/img/home_4.svg')
        },
        {
          text: 'Mobile Home',
          image: require('../../assets/img/mobile_home.svg')
        }
      ]
    }
  },
  methods: {
    handleClick (value) {
      this.$emit('input', value)
    }
  }
}
</script>
